export const SECOND_IN_MS = 1000;
export const MINUTE_IN_MS = 60 * SECOND_IN_MS;
export const HOUR_IN_MS = 60 * MINUTE_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;

export type DateLike = Date | number | string;

export enum Days {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 0,
}
export enum Months {
  JANUARY = 0,
  FEBRUARY = 1,
  MARCH = 2,
  APRIL = 3,
  MAY = 4,
  JUNE = 5,
  JULY = 6,
  AUGUST = 7,
  SEPTEMBER = 8,
  OCTOBER = 9,
  NOVEMEBER = 10,
  DECEMBER = 11,
}

export const DAY_NAMES = {
  [Days.MONDAY]: 'monday',
  [Days.TUESDAY]: 'tuesday',
  [Days.WEDNESDAY]: 'wednesday',
  [Days.THURSDAY]: 'thursday',
  [Days.FRIDAY]: 'friday',
  [Days.SATURDAY]: 'saturday',
  [Days.SUNDAY]: 'sunday',
};

export const SHORT_DAY_NAMES = {
  [Days.MONDAY]: 'mon',
  [Days.TUESDAY]: 'tue',
  [Days.WEDNESDAY]: 'wed',
  [Days.THURSDAY]: 'thu',
  [Days.FRIDAY]: 'fri',
  [Days.SATURDAY]: 'sat',
  [Days.SUNDAY]: 'sun',
};

export const MONTH_NAMES = {
  [Months.JANUARY]: 'january',
  [Months.FEBRUARY]: 'february',
  [Months.MARCH]: 'march',
  [Months.APRIL]: 'april',
  [Months.MAY]: 'may',
  [Months.JUNE]: 'june',
  [Months.JULY]: 'july',
  [Months.AUGUST]: 'august',
  [Months.SEPTEMBER]: 'september',
  [Months.OCTOBER]: 'october',
  [Months.NOVEMEBER]: 'november',
  [Months.DECEMBER]: 'december',
};

export const SHORT_MONTH_NAMES = {
  [Months.JANUARY]: 'jan',
  [Months.FEBRUARY]: 'feb',
  [Months.MARCH]: 'mar',
  [Months.APRIL]: 'apr',
  [Months.MAY]: 'may',
  [Months.JUNE]: 'jun',
  [Months.JULY]: 'jul',
  [Months.AUGUST]: 'aug',
  [Months.SEPTEMBER]: 'sep',
  [Months.OCTOBER]: 'oct',
  [Months.NOVEMEBER]: 'nov',
  [Months.DECEMBER]: 'dec',
};

export const floorTimestamp = (
  date?: DateLike,
  to: number = SECOND_IN_MS
): number => {
  date = new Date(date || new Date());
  return Math.floor(+date / to) * to;
};

export const getMiddayTimestamp = (date?: DateLike): number => {
  date = new Date(date || new Date());
  return floorTimestamp(date.setHours(12), HOUR_IN_MS);
};

export const offsetDateByDays = (date?: DateLike, days: number = 0): Date => {
  date = new Date(date || new Date());
  return new Date(
    new Date(date.setDate(date.getDate() + days)).setHours(date.getHours())
  );
};

export const getDayOfWeek = (
  date?: DateLike,
  day: number = Days.MONDAY
): Date => {
  date = new Date(date || new Date());
  return offsetDateByDays(date, (day - date.getDay()) % 7);
};

export const getFirstDayOfMonth = (date?: DateLike): Date => {
  date = new Date(date || new Date());
  return new Date(getMiddayTimestamp(date.setDate(1)));
};

export const getLastDayOfMonth = (date?: DateLike): Date => {
  date = new Date(date || new Date());
  return new Date(
    getMiddayTimestamp(new Date(date.setMonth(date.getMonth() + 1)).setDate(0))
  );
};

export const getDaysInMonth = (date?: DateLike): number => {
  return getLastDayOfMonth(date).getDate();
};

export const dateInRange = (
  date?: DateLike,
  range?: [from: DateLike, to: DateLike]
): boolean => {
  if (!range) return false;
  const _date = new Date(date || new Date()).toISOString().slice(0, 10);
  const _from = new Date(range[0]).toISOString().slice(0, 10);
  const _to = new Date(range[1]).toISOString().slice(0, 10);
  return _date >= _from && _date <= _to;
};
